export const CONFIG = {
//   ETH: {
//     network: {
//       symbol: "ETH",
//       name: "Ethereum Rinkeby",
//       network: "rinkeby",
//       chain_id: 4,
//       network_id: 4,
//       rpc_url: `https://rinkeby.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
//       targetBridgeChainId: 1,
//       refreshClaimTimestamp: 15000,
//       blockExplorer: "https://rinkeby.etherscan.io/tx",
//     },
//     contracts: {
//       Factory: "0xD0c0dA37656D8F241c188825d7806c5E3E107995",
//       Albt: ""
//     },
//     validators: {
//       london: "https://validator1.alliancebridge-dev.net:5200",
//       "north virginia": "https://validator2.alliancebridge-dev.net:5200",
//       singapore: "https://validator3.alliancebridge-dev.net:5200",
//     },
//   },
  BSC: {
    network: {
      symbol: "BSC",
      name: "Smart Chain - Testnet",
      network: "binance",
      chain_id: 97,
      network_id: 97,
      rpc_url: "https://data-seed-prebsc-1-s1.binance.org:8545/",
      targetBridgeChainId: 2,
      refreshClaimTimestamp: 15000,
      blockExplorer: "https://testnet.bscscan.com/tx",
    },
    contracts: {
      Factory: "",
      Albt: ""
    },
    validators: {
      london: "https://validator1.alliancebridge-dev.net:5200",
      "north virginia": "https://validator2.alliancebridge-dev.net:5200",
      singapore: "https://validator3.alliancebridge-dev.net:5200",
    },
  },
  AVAX: {
    network: {
      symbol: "AVAX",
      name: "AVALANCHE FUJI",
      network: "avax",
      chain_id: 43113,
      network_id: 43113,
      rpc_url: `https://api.avax-test.network/ext/bc/C/rpc`,
      targetBridgeChainId: 3,
      refreshClaimTimestamp: 15000,
      blockExplorer: "https://explorer.avax-test.network/tx",
    },
    contracts: {
      Factory: "",
      Albt: ""
    },
    validators: {
      london: "https://validator1.alliancebridge-dev.net:5200",
      "north virginia": "https://validator2.alliancebridge-dev.net:5200",
      singapore: "https://validator3.alliancebridge-dev.net:5200",
    },
  },
  Mumbai: {
    network: {
      symbol: "MATIC",
      name: "Matic - Mumbai",
      network: "mumbai",
      chain_id: 80001,
      network_id: 80001,
      rpc_url: "https://rpc-mumbai.maticvigil.com",
      targetBridgeChainId: 4,
      refreshClaimTimestamp: 15000,
      blockExplorer: "https://explorer-mumbai.maticvigil.com/tx",
    },
    contracts: {
      Factory: "0x030B1e617a6fA972Fc5f94A566CD6a5E1e3215F3",
      Albt: "0x6F6Fa4a30414e10681D0dFF987fEf8dfef5137Af"
    },
    validators: {
      london: "https://validator1.alliancebridge-dev.net:5200",
      "north virginia": "https://validator2.alliancebridge-dev.net:5200",
      singapore: "https://validator3.alliancebridge-dev.net:5200",
    },
  },
  Volta: {
    network: {
      symbol: "EWC",
      name: "Energy - Volta",
      network: "volta",
      chain_id: 73799,
      network_id: 73799,
      rpc_url: "https://volta-rpc.energyweb.org",
      targetBridgeChainId: 5,
      refreshClaimTimestamp: 15000,
      blockExplorer: "https://volta-explorer.energyweb.org/tx",
    },
    contracts: {
      Factory: "0x5eB2ba155d64060D6EaAf931C2c08D867b8b66F1",
      Albt: "0x282807bd22F4F7c4E4F77cA684425c4fDb13ce9b"
    },
    validators: {
      london: "https://validator1.alliancebridge-dev.net:5200",
      "north virginia": "https://validator2.alliancebridge-dev.net:5200",
      singapore: "https://validator3.alliancebridge-dev.net:5200",
    },
  },
  ARBITRUM: {
    network: {
      symbol: "ARBITRUM",
      name: "ArbRinkeby",
      network: "arbitrum",
      chain_id: 421611,
      network_id: 421611,
      rpc_url: "https://rinkeby.arbitrum.io/rpc",
      targetBridgeChainId: 6,
      refreshClaimTimestamp: 15000,
      blockExplorer: "https://rinkeby-explorer.arbitrum.io/tx",
    },
    contracts: {
      Factory: "",
      Albt: ""
    },
    validators: {
      london: "https://validator1.alliancebridge-dev.net:5200",
      "north virginia": "https://validator2.alliancebridge-dev.net:5200",
      singapore: "https://validator3.alliancebridge-dev.net:5200",
    },
  },
  OPTIMISTIC: {
    network: {
      symbol: "OPTIMISTIC",
      name: "Optimistic Kovan",
      network: "optimistic",
      chain_id: 69,
      network_id: 69,
      rpc_url: "https://kovan.optimism.io",
      targetBridgeChainId: 7,
      refreshClaimTimestamp: 15000,
      blockExplorer: "https://kovan-optimistic.etherscan.io/tx",
    },
    contracts: {
      Factory: "",
      Albt: ""
    },
    validators: {
      london: "https://validator1.alliancebridge-dev.net:5200",
      "north virginia": "https://validator2.alliancebridge-dev.net:5200",
      singapore: "https://validator3.alliancebridge-dev.net:5200",
    },

    threshold: "1000000000000000",
  },
};

export const PK = `${process.env.REACT_APP_WALLET_PK}`